const initialState = {
  message: '',
  severity: 'success', // Other options are 'warning', error
  autoHideDuration: 3000,
  openSnackbar: false
}

const initialAction = {
  type: '',
  payload: {}
};

// action
export const showSnackbar = (data) => ({ type: 'SHOW_SNACKBAR', payload: data });

// Reducers
export const showSnackbarReducer = (state = initialState, action = initialAction) => {
  if (action.type === 'SHOW_SNACKBAR') {
    let tempPayload = { ...action.payload }
    if (!Object.keys(tempPayload).includes('openSnackbar')) {
      return { ...initialState, ...tempPayload, openSnackbar: true }
    }
    return { ...state, ...tempPayload };
  } else { return { ...state }; }
};

// Selectors
export const getsnackbarData = (state) => state.snackbarData;
